import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import { MPL_PRODUCT_TYPES } from 'commonTypes/api/scenarios/ProductType';

import type { TLoansApplicationV2Data } from 'shared/types/TLoansService';

const PRODUCT_TYPES_MAP: Record<
  MPLPreApprovalOffer['productType'],
  TLoansApplicationV2Data['customer']['productType']
> = {
  [MPL_PRODUCT_TYPES.CREDIT]: 'Credit',
  [MPL_PRODUCT_TYPES.CREDIT_CARD]: 'CreditCard',
  [MPL_PRODUCT_TYPES.MICROCREDIT]: 'MicroCredit',
};

export const mapMplProductTypeToLeadGenProductType = (
  productType: MPLPreApprovalOffer['productType'],
): TLoansApplicationV2Data['customer']['productType'] => {
  return PRODUCT_TYPES_MAP[productType] || 'Credit';
};
